
import { Body, Controller, Post, Req } from '@nestjs/common';
import { ApiBody, ApiTags } from '@nestjs/swagger';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages'
import { WorkersService } from './workers.service';
import { CommonResponse } from '@gtpl/shared-models/production-management';
import { WorkerRequest } from './dto/worker.request';
import { WorkerDTO } from './dto/worker.dto';
import { ContractorIdReq } from '@gtpl/shared-models/masters';

@ApiTags('workers')
@Controller('workers')
export class WorkersController {
    constructor(private service: WorkersService,
        private readonly applicationExceptionhandler: ApplicationExceptionHandler,
    ) {

    }

    @Post('/createWorker')
    @ApiBody({type:WorkerDTO})
    async createWorker(@Body() req:any): Promise<CommonResponse> {
        try {
            return this.service.createWorker(req,false);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(CommonResponse, err);
        }
    }

    @Post('/updateWorker')
    async updateWorker(@Body() req: WorkerDTO): Promise<CommonResponse> {
        try {
            return this.service.createWorker(req, true);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(CommonResponse, err);
        }
    }
    


    @Post('/getAllworkerData')
    async getAllworkerData(): Promise<CommonResponse> {
        try {
            return this.service.getAllworkerData();
        } catch (err) {
            return this.applicationExceptionhandler.returnException(CommonResponse, err);
        }
    }


    @Post('/getAllActiveworkerData')
    async getAllActiveworkerData(): Promise<CommonResponse> {
        try {
            return this.service.getAllActiveworkerData();
        } catch (err) {
            return this.applicationExceptionhandler.returnException(CommonResponse, err);
        }
    }

    
    @Post('/activateOrDeactivateworker')
    @ApiBody({type:WorkerRequest})
    async activateOrDeactivateworker(@Body() req:any): Promise<CommonResponse> {
        try {
            return this.service.activateOrDeactivateworker(req);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(CommonResponse, err);
        }
    }

    @Post('/getWorkersAgainstContractor')
    async getWorkersAgainstContractor(@Body() req:ContractorIdReq): Promise<CommonResponse> {
        try {
            return this.service.getWorkersAgainstContractor(req);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(CommonResponse, err);
        }
    }



}
